import React, { FC } from 'react';
import { Form, Input, InputGroup, RadioGroup, Radio } from 'rsuite';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import RenderCustomElement from '../contact/components/RenderCustomElement';
import { Editor } from 'react-draft-wysiwyg';

const CustomHelperTextError = () => (
  <div
    style={{
      color: 'red',
      display: 'flex',
      alignItems: 'center',
      margin: '4px 0',
    }}
  >
    <ErrorOutlineOutlinedIcon style={{ marginRight: '4px' }} />
    <span>This field is required</span>
  </div>
);

export const emailTemplateForm: FC = (emailInputData: any) => {
  const {
    fields,
    editorState,
    handleEditorChange,
    editorBody,
    checkEmptyForm,
  } = emailInputData;
  return (
    <>
      {fields.map((field) => (
        <Form.Group>
          <Form.ControlLabel>{field.name}</Form.ControlLabel>
          <Input
            style={{ width: '100%' }}
            placeholder={field.name}
            onChange={field.onChange}
            disabled={field.fieldStatus === 'LOADING'}
            value={field.value}
          />
          {field.checkEmptyForm && !field.value && <CustomHelperTextError />}
        </Form.Group>
      ))}
      <Form.Group>
        <Form.ControlLabel>Text Body</Form.ControlLabel>
        <Editor
          editorState={editorState}
          toolbarClassName='toolbarClassName'
          wrapperClassName='wrapperClassName'
          editorClassName='editorClassName'
          onEditorStateChange={handleEditorChange}
          editorStyle={{
            backgroundColor: '#fcfcfc',
            minHeight: '150px',
            border: '1px solid #ccc',
            padding: '4px 10px',
          }}
          toolbarStyle={{
            backgroundColor: '#fcfcfc',
            border: '1px solid #ccc',
          }}
          toolbarCustomButtons={[<RenderCustomElement />]}
        />
        {checkEmptyForm && (!editorBody || editorBody === '<p></p>') && (
          <CustomHelperTextError />
        )}
      </Form.Group>
    </>
  );
};

export const smsTemplateForm: FC = (smsInputData: any) => {
  const { fields } = smsInputData;
  return (
    <>
      {fields.map((field) => {
        switch (field.type) {
          case 'input':
            return (
              <Form.Group>
                <Form.ControlLabel>{field.name}</Form.ControlLabel>
                <Input
                  style={{ width: '100%' }}
                  placeholder={field.name}
                  onChange={field.onChange}
                  disabled={field.status}
                  value={field.value}
                />
                {field.checkEmptyForm && !field.value && (
                  <CustomHelperTextError />
                )}
              </Form.Group>
            );
          case 'textarea':
            return (
              <Form.Group>
                <Form.ControlLabel>{field.name}</Form.ControlLabel>
                <Input
                  as='textarea'
                  rows={5}
                  placeholder={field.name}
                  value={field.value}
                  onChange={field.onChange}
                />
                {field.checkEmptyForm && !field.value && (
                  <CustomHelperTextError />
                )}
              </Form.Group>
            );
        }
      })}
    </>
  );
};
